export default {
  translatedCalibrationHomepageMessage: state => state.translatedCalibrationHomepageMessage
}
